import type { AppSettings } from './settings';
import { Entity } from '../../types/interfaces';

export enum SHOT_THUMBNAIL_TYPES {
	SHOWBOARD = 1,
	SHOTS_TAB = 2,
	SHOW_DETAILS = 3,
	TELEPROMPTER = 4,
}

export interface ShotFeed {
	media: number | null;		// id of media
	presenter: number | null;	// brandlive profile
	email: string | null;		// used when settings someone in a shot that hasnt made a bl profile yet
	screenshare: string | null; // email for user in a shot who is screensharing
	sipStreamId: string | null;
	srtStreamId?: number | null;
	onsiteLocationId?: number | null;
	feedType: string;
	position: number;	// which slot this feed goes in
	presenterDeleted?: boolean;
	audioOnly?: boolean;
	expanded?: boolean;
}

export interface ShotData {
	// the layout chosen when creating the shot
	forcedLayout: string;
	// the title of a shot
	shotTitle: string;
	// if titles are enabled for the shot as a whole (false means no titles at all)
	videoTitlesOn: boolean;
	shotFeeds: ShotFeed[];
	shotDuration: number; // the expected time length of the shot in seconds
	order: number;	// position of this shot in the showboard
	cue: string;	// user input
	note: string;	// user input
	shotGraphics?: Array<number>;
	autoplay: boolean;
	autoDuration: boolean;
}

export interface Shot {
	shot_id: number; 						// unique key
	created_by: number; 					// user id of creator
	edited_by: number;
	edited: string;
	meeting: number; 						// meeting shot corresponds to
	shot_style: {
		queue: AppSettings;
		applied: AppSettings
	}
	shot_data: ShotData;
	thumbnail_url?: string;
	segment_id?: number;
}

export interface ShotsState {
	shots: Shot[];
	addingShot: boolean;
	editingShot: boolean;
	loadingShots: boolean;
	shotsLoaded: boolean;
	addingShotError: string;
	editingShotError: string;
	loadingShotsError: string;
	shotStartTimestampEntity: Entity | null;
	shotModalShot: Shot;
	shotIdToDelete: number | null;
	previousShotId: number;
	currentShotId: number;
	videoTitlesHaveFired: boolean;
	canvasStyle: AppSettings;
	deletedShotOrder: number | null;
	currentShotIdEntity: Entity | null;
	shotTabShotId: number;
	shotModalEditTimestamp: number;
}
